function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "InfoHintDark"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_101",
  className: "background",
  "data-name": "Ellipse 101",
  cx: 10,
  cy: 10,
  r: 10,
  transform: "translate(0 1)",
  fill: "#002d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "i",
  className: "info",
  transform: "translate(7 4)",
  fill: "#fff",
  d: "M.979 12v-1.282l1.032-.22V5.585L.87 5.364V4.075h3.28V10.5l1.026.22V12H.98zm.959-9.602V.574H4.15v1.824H1.938z"
}));

function SvgInfoHint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoHint);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIwIDIxIj4KICA8ZyBpZD0iSW5mb0hpbnREYXJrIj4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTAxIiBjbGFzcz0iYmFja2dyb3VuZCIgZGF0YS1uYW1lPSJFbGxpcHNlIDEwMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIiBmaWxsPSIjMDAyZDU2Ii8+CiAgICA8cGF0aCBpZD0iaSIgY2xhc3M9ImluZm8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcsIDQpIiBmaWxsPSIjZmZmIiBkPSJNMC45Nzg1MDc4MTMsMTIgTDAuOTc4NTA3ODEzLDEwLjcxODI2MTcgTDIuMDExMjIyNjYsMTAuNDk4NTM1MiBMMi4wMTEyMjI2Niw1LjU4Mzk4NDM4IEwwLjg2ODY0NDUzMSw1LjM2NDI1NzgxIEwwLjg2ODY0NDUzMSw0LjA3NTE5NTMxIEw0LjE0OTg5NDUzLDQuMDc1MTk1MzEgTDQuMTQ5ODk0NTMsMTAuNDk4NTM1MiBMNS4xNzUyODUxNiwxMC43MTgyNjE3IEw1LjE3NTI4NTE2LDEyIEwwLjk3ODUwNzgxMywxMiBaIE0xLjkzNzk4MDQ3LDIuMzk3OTQ5MjIgTDEuOTM3OTgwNDcsMC41NzQyMTg3NSBMNC4xNDk4OTQ1MywwLjU3NDIxODc1IEw0LjE0OTg5NDUzLDIuMzk3OTQ5MjIgTDEuOTM3OTgwNDcsMi4zOTc5NDkyMiBaIiAvPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };